import Module from '../schema/Module';
import ModuleSwitcherItem from '../schema/ModuleSwitcherItem';
import strings from 'owa-strings/owa-mini-common-strings';
import { getCalendarSurfaceStore } from 'mini-calendar-surface-store';
import { getIconClassName, mergeStyles } from '@uifabric/styling/lib/index';
import { getOwaMiniCommonStrings } from 'owa-strings/owa-mini-common-strings';
import { getOwaMiniExtensionStrings } from 'owa-strings/owa-mini-extension-strings';
import { isSameDay } from 'owa-datetime';
import { MiniIcons } from 'owa-mini-icons';

export interface ModuleSwitcherIconRefs {
    mailIconRef?: React.RefObject<any>;
    calendarIconRef?: React.RefObject<any>;
    peopleIconRef?: React.RefObject<any>;
    todoIconRef?: React.RefObject<any>;
}

function getCalendarTitle(): string {
    const { selectedDate, todayDate } = getCalendarSurfaceStore();

    if (isSameDay(selectedDate, todayDate)) {
        return strings.moduleCalendarLabel;
    }
    return strings.moduleCalendarJumpToTodayString;
}

/**
 * Utility to get the items with their properties to be shown in the footer of the reading pane
 */
export default function getModuleSwitcherItems(
    iconRefs: ModuleSwitcherIconRefs
): ModuleSwitcherItem[] {
    const strings = getOwaMiniCommonStrings();
    const todoStrings = getOwaMiniExtensionStrings();
    const { mailIconRef, calendarIconRef, peopleIconRef, todoIconRef } = iconRefs || {};

    return [
        {
            moduleType: Module.Mail,
            icon: getIconClassName(MiniIcons.Mail),
            ariaLabel: strings.moduleMailAriaLabel,
            ariaLabelWhenSelected: strings.moduleMailSelectedAriaLabel,
            iconRef: mailIconRef,
            className: mergeStyles({ fontSize: '18px' }),
        },
        {
            moduleType: Module.Calendar,
            icon: getIconClassName(MiniIcons.Calendar),
            ariaLabel: strings.moduleCalendarLabel,
            title: getCalendarTitle(),
            ariaLabelWhenSelected: strings.moduleCalendarLabel,
            iconRef: calendarIconRef,
        },
        {
            moduleType: Module.People,
            icon: getIconClassName(MiniIcons.People),
            ariaLabel: strings.modulePeopleAriaLabel,
            ariaLabelWhenSelected: strings.modulePeopleSelectedAriaLabel,
            iconRef: peopleIconRef,
            className: mergeStyles({ fontSize: '18px' }),
        },
        {
            moduleType: Module.ToDo,
            icon: getIconClassName(MiniIcons.ToDoLogoOutline),
            ariaLabel: todoStrings.moduleName,
            ariaLabelWhenSelected: todoStrings.moduleName,
            iconRef: todoIconRef,
            className: mergeStyles({ fontSize: '18px' }),
        },
    ];
}
